<template>
  <v-container
    class="LKPublicationsFormdataListFilter"
  >
    <v-row dense>
      <v-col cols="12">
        <BTextField
          v-model="form.search"
          :label="label"
          :loading="isLoading"
          :skeleton="skeleton"
          :placeholder="placeholder"
          @input="onChangeDebounced"
          @keydown="onKeyDown"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col md :sm="12">
        <BTextFieldAte
          :region.sync="form.region"
          :municipality.sync="form.municipality"
          :school.sync="form.school"
          :skeleton="skeleton"
          model="User"
          style="min-width: 320px;"
          placeholder="Выберите ATE"
          @change="onChangeDebounced"
          @click:clear="onClearAte"
        />
      </v-col>

      <v-col md="auto" :sm="6">
        <BAutocompleteSelect
          v-model="form.status"
          :skeleton="skeleton"
          :options="statuses"
          item-value="value"
          item-text="text"
          :return-object="false"
          label="Статус"
          class="LKPublicationsFormdataListFilter__Status"
          @change="onChangeDebounced"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { FormdataStatusesFilterOptions } from '@/typings/api/Formdata'
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'
import BTextFieldAte from './LKTextFieldAteFormdata.vue'
import BAutocompleteSelect from '@/components/forms/BAutocompleteCommon/BAutocompleteSelect.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
  status: void 0,
  region: void 0,
  municipality: void 0,
  school: void 0,
})

export default {
  name: 'UsersFilter',
  components: {
    BAutocompleteSelect,
    BTextFieldAte,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
  data: () => ({
    statuses: FormdataStatusesFilterOptions,
  }),
  methods: {
    onClearAte() {
      this.form = {
        ...this.form,
        region: void 0,
        municipality: void 0,
        school: void 0,
      }

      this.onChangeDebounced()
    },
    setFilters(filters) {
      this.form = {
        ...this.form,
        ...filters,
      }
      this.onChangeDebounced()
    },
  },
}
</script>

<style lang="scss">
.BAteTreeFormRecursiveCheckbox {
  padding: 0;
  margin: 0;
}

.b-ate-tree-form-recursive {
  padding-top: 0;
  padding-bottom: 0;
}

.LKPublicationsFormdataListFilter {
  &__Status {
    .v-input__slot {
      height: 44px;
    }
  }
}
</style>
